<template>
  <div class="footer-main">
    <div class="content">
      <div class="link">
        <div class="link-content">
          <div class="link-list" v-for="(item, index) in menu" :key="index">
            <a class="link-item" v-for="opt in item" :key="opt.label" :href="opt.url" @click="to($event, opt.url, opt.targer, opt.event)">
              <span>{{opt.label}}</span>
              <div class="box" v-if="opt.img">
                <p class="name">{{opt.label === '微信' ? '微信公共号' : opt.label}}</p>
                <img :src="opt.img" alt="">
              </div>
            </a>
          </div>
        </div>
        <div class="right-logo" v-if="false">
          <img src="https://files.wondercv.com/translate-img/new_wondercv_logo_zh-CN.png" alt="logo" class="logo">
          <img src="https://files.wondercv.com/default_wx_qr.png" alt="">
        </div>
      </div>
      <img src="https://files.wondercv.com/translate-img/new_wondercv_logo_zh-CN.png" alt="logo" class="left-logo">
      <p class="copy">©2021 超级简历 WonderCV wondercv.com | <a href="http://beian.miit.gov.cn/" target="_blank">京ICP备17055181号</a></p>
    </div>
  </div>
</template>
<script>
const menu = [
  [
    {label: '联系我们', url: '/welcome/contact_us'},
    {label: '在线客服', url: '', event: 'showUdesk'},
    {label: '微信', url: '', img: 'https://files.wondercv.com/%E8%B6%85%E7%BA%A7%E7%AE%80%E5%8E%86%E5%BE%AE%E4%BF%A1%E5%85%AC%E4%BC%97%E5%8F%B7%E4%BA%8C%E7%BB%B4%E7%A0%81.jpg'},
    {label: '微博', url: 'http://weibo.com/u/5637586262?refer_flag=1001030101_'},
    {label: '知乎', url: 'https://www.zhihu.com/org/chao-ji-jian-li-wondercv'}
  ],
  [
    // {label: '关于我们', url: '/welcome/about_us'},
    {label: '关于我们', url: '/welcome/join_us'},
    {label: '产品介绍', url: '/blog/3am30kvd.html'},
    {label: '服务协议', url: '/agreement'},
    {label: '隐私条款', url: '/privacy'},
    {label: '加入我们', url: '/welcome/join_us'},
    {label: '网站地图', url: '/sitemap', targer: '_blank'}
  ],
  [
    {label: '快速进入', url: '/jianlimoban'},
    {label: '首页', url: '/', targer: '_blank'},
    {label: '我的简历', url: '/cvs'},
    {label: '简历攻略', url: '/blog/'},
    {label: '简历修改', url: '/service/'},
    {label: '职位列表', url: '/recruit_infos/spider_index', targer: '_blank'}
  ],
  [
    {label: '简历模板', url: '/jianlimoban/', targer: '_blank'},
    {label: '学生简历模板', url: '/jianlimoban/daxuesheng/', targer: '_blank'},
    {label: '英文简历模板', url: '/jianlimoban/yingwen/', targer: '_blank'},
    {label: '程序员简历模板', url: '/jianlimoban/chengxuyuan/', targer: '_blank'},
    {label: '经典工作简历', url: '/jianlimoban/qiuzhi/', targer: '_blank'},
    {label: '秋招礼包', url: '/blog/d5kd9gzo.html', targer: '_blank'}
  ],
  [
    {label: '其他产品', url: '/comp_recruit_infos/user_show'},
    {label: '下载 App', url: '', img: 'https://files.wondercv.com/appDownloadIcon.png'},
    {label: '微信小程序', url: '', img: 'https://files.wondercv.com/wondercv_miniprogram.jpg'},
    {label: '大牛简历', url: '', img: 'https://photo.wondercv.com/%E5%A4%A7%E7%89%9B%E4%BA%8C%E7%BB%B4%E7%A0%81-Mobile@2x.png'},
    {label: '微信名片', url: '', img: 'https://files.wondercv.com/gh_a98fba593556_344.jpg'}
  ]
];
import {routerTo} from '@/assets/js/util';
export default {
  name: 'pcFooter',
  data() {
    return {
      menu
    }
  },
  methods: {
    to($event, path, targer, event) {
      if (event) {
        $event.preventDefault();
        this[event]();
        return false;
      }
      if (!path) {
        // return false;
        $event.preventDefault();
      }
    },
    showUdesk() {
      let udesk_container = document.querySelector('#udesk_btn a');
      if(udesk_container!=null){
        udesk_container.click();
      }
    }
  },
}
</script>
<style lang="scss" scoped>
  .footer-main {
    background: #f2f2f5;
    padding-bottom: 40px;
    .content {
      padding-top: 38px;
      width: 1200px;
      margin: auto;
      position: relative;
      .left-logo {
        width: 120px;
        position: absolute;
        top: 38px;
        left: 0;
      }
      .right-logo {
        width: 120px;
        margin-left: 100px;
        img {
          width: 100%;
          margin-bottom: 20px;
          &:last-child {
            margin-bottom: -50px;
          }
        }
      }
      .link {
        display: flex;
        justify-content: center;
        .link-content {
          display: flex;
          justify-content: center;
        }
        .link-list {
          width: 167px;
          &:last-child {
            width: auto;
          }
          .link-item {
            display: block;
            width: fit-content;
            color: #404040;
            font-size: 13px;
            margin-bottom: 12px;
            position: relative;
            cursor: pointer;
            &:hover {
              text-decoration: underline;
              .box {
                display: block;
              }
            }
            &:first-child {
              color: #9B9B9B;
            }
            &:last-child {
              margin: 0;
            }
            .box {
              display: none;
              width: 168px;
              height: 190px;
              background: #fff;
              box-shadow: 0 5px 10px rgba(0,0,0,0.2);
              border: 1px solid rgba(0,0,0,0.2);
              background: #fff;
              position: absolute;
              top: -200px;
              left: 50%;
              transform: translateX(-50%);
              border-radius: 6px;
              .name {
                height: 30px;
                line-height: 30px;
                font-size: 14px;
                border-bottom: 1px solid #ebebeb;
                background: #f7f7f7;
                padding: 0 14px;
                border-radius: 6px 6px 0 0;
              }
              img {
                width: 140px;
                height: 140px;
                margin: 9px auto 0;
                background: #ccc;
              }
              &::after {
                content: "";
                display: block;
                width: 11px;
                height: 11px;
                transform-origin: 50% 50%;
                position: absolute;
                bottom: -7px;
                left: 50%;
                transform: translateX(-50%) rotate(45deg);
                background: #fff;
                border-right: 1px solid rgba(0,0,0,0.2);
                border-bottom: 1px solid rgba(0,0,0,0.2);
              }
            }
          }
        }
      }
      .copy {
        color: #9B9B9B;
        font-size: 13px;
        margin-top: 36px;
        text-align: center;
        a{
          color: #9B9B9B;
          &:hover{
            text-decoration: underline;
          }
        }
      }
    }
  }
</style>
